import { on } from 'delegated-events'
import { slideToggle } from '../common/slide'

const fn = {
  init: () => {
    on('click', '[data-slide-toggle]', fn.handleToggle)
    on('keyup', '[data-slide-toggle]', fn.handleToggle)
  },

  handleToggle: (e) => {
    if (e.type === 'keyup' && e.keyCode !== 13) {
      return
    }

    const trigger = e.target.closest('[data-slide-toggle]')

    if (!trigger) {
      return
    }

    const target = document.getElementById(trigger.getAttribute('aria-controls'))

    if (!target) {
      return
    }

    if (trigger.getAttribute('aria-expanded') === 'false') {
      slideToggle(target)
      trigger.setAttribute('aria-expanded', 'true')
    } else {
      slideToggle(target)
      trigger.setAttribute('aria-expanded', 'false')
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
